module.exports = require("react-stripe-elements");


//////////////////
// WEBPACK FOOTER
// external "react-stripe-elements"
// module id = 20
// module chunks = 0